import React, { FC } from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { MarkdownQueryI } from '../types/common'
import { PostI } from '../types/data-models'

interface WidgetI {
  post: MarkdownQueryI<PostI>
  thumbnail?: IGatsbyImageData
}

const Widget: FC<WidgetI> = ({ post, thumbnail }) => (
  <article className="post featured">
    <header className="major">
      {post.fields.slug && (
        <h2>
          <Link to={post.fields.slug}>{post.frontmatter.title}</Link>
        </h2>
      )}
      {post.excerpt && <p style={{ fontSize: '1.1rem' }} dangerouslySetInnerHTML={{ __html: post.excerpt }} />}
    </header>
    {thumbnail && (
      <Link
        to={post.fields.slug}
        className="image main"
        aria-label={post.frontmatter.coverImage?.label ?? 'post thumbnail'}
      >
        <GatsbyImage
          image={thumbnail}
          alt={post.frontmatter.coverImage?.label ?? 'post thumbnail'}
          imgStyle={{
            transition: 'transform 0.2s ease,-webkit-transform 0.2s ease',
          }}
        />
      </Link>
    )}
  </article>
)

export default Widget
